import {
  ActionOutboxEntityType,
  CatalogResults,
  EventWithData,
  Listing,
  PurchaseOrderTicketGroup,
  Sale,
} from 'src/WebApiController';
import { useContextSelector } from 'use-context-selector';

import {
  ISearchDataContext,
  SearchDataContextWithSelector,
} from './SearchDataContext.types';

const useSearchDataContextValueSelector = <T>(
  selector: (context: ISearchDataContext) => T
): T => {
  const contextValue = useContextSelector(
    SearchDataContextWithSelector,
    selector
  );

  return contextValue;
};

export const useSearchDataContextIsEnabledSelector = (): boolean => {
  return useSearchDataContextValueSelector((context) => context.isEnabled);
};

export const useSearchDataContextIsLoadingSelector = (): boolean => {
  return useSearchDataContextValueSelector((context) => context.isLoading);
};

export const useSearchDataContextIsFetchingSelector = (): boolean => {
  return useSearchDataContextValueSelector((context) => context.isFetching);
};

export const useSearchDataContextErrorInfoSelector = ():
  | { errorHeader: React.ReactNode; errorMessage: React.ReactNode }
  | undefined => {
  return useSearchDataContextValueSelector((context) => context.errorInfo);
};

export const useSearchDataContextEventsTransformedSelector = ():
  | EventWithData[]
  | undefined => {
  return useSearchDataContextValueSelector(
    (context) => context.eventsTransformed
  );
};

export const useSearchDataContextDataSelector = ():
  | CatalogResults
  | undefined => {
  return useSearchDataContextValueSelector((context) => context.data);
};

export const useSearchDataContextTotalItemsCountSelector = ():
  | number
  | null
  | undefined => {
  return useSearchDataContextValueSelector(
    (context) => context.totalItemsCount
  );
};

export const useSearchDataContextPitIdSelector = ():
  | string
  | null
  | undefined => {
  return useSearchDataContextValueSelector((context) => context.pitId);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useSearchDataContextSearchAfterSelector = ():
  | any[]
  | null
  | undefined => {
  return useSearchDataContextValueSelector((context) => context.searchAfter);
};

export const useSearchDataContextSortedItemIdsSelector = ():
  | number[]
  | null
  | undefined => {
  return useSearchDataContextValueSelector((context) => context.sortedItemIds);
};

export const useSearchDataContextRefetchSelector = (): (() => void) => {
  return useSearchDataContextValueSelector((context) => context.refetch);
};

export const useSearchDataContextDelayedRefetchSelector = (): (() => void) => {
  return useSearchDataContextValueSelector((context) => context.delayedRefetch);
};

export const useSearchDataContextIsRefreshingAfterBulkEditSelector =
  (): boolean => {
    return useSearchDataContextValueSelector(
      (context) => context.isRefreshingAfterBulkEdit
    );
  };

export const useSearchDataContextUpdateItemInEventSelector = (): ((
  item: Listing | Sale | PurchaseOrderTicketGroup,
  entityType: ActionOutboxEntityType,
  sectionalUpdate?: boolean
) => void) => {
  return useSearchDataContextValueSelector(
    (context) => context.updateItemInEvent
  );
};
